import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../environments/environment';
import { MatSnackBar, MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { VerifyMobileComponent } from './../components/auth/verify-mobile/verify-mobile.component';
import { Subject } from 'rxjs';
import { ResetPasswordComponent } from '../components/auth/reset-password/reset-password.component';
import { LoginComponent } from '../components/auth/login/login.component';

const apiUrl = environment.apiURL;

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private token: string;
  private isAuthenticated: boolean = false;
  isAuthenticatedSub = new Subject<boolean>();

  constructor(private http: HttpClient, private snackBar: MatSnackBar, private dialog: MatDialog, private router: Router) { }

  getToken() {
    return this.token;
  }

  getIsAuth() {
    return this.isAuthenticated;
  }

  getIsUserAuthenticated() {
    return this.isAuthenticated;
  }

  getIsUserAuthenticatedUpdated() {
    return this.isAuthenticatedSub.asObservable();
  }

  login(data) {
    this.http.put<{ success: boolean, data: { token: string, name: string, userType: string } }>(`${apiUrl}/admins`, data).subscribe(result => {
      this.token = result.data.token;

      if (result.data.token) {
        this.isAuthenticated = true;
        this.saveAuthData(this.token);

        const user = {
          name: result.data.name,
          userType: result.data.userType
        }

        localStorage.setItem('user', JSON.stringify(user))

        if (this.isAuthenticated) {
          this.snackBar.open('Welcome to Honest Green!', 'Dismiss', {
            duration: 3000
          })

          this.router.navigate(['admin/baskets'])
        } else {
          this.snackBar.open('Email or passwors is incorrect!', 'Dismiss', {
            duration: 3000
          })
        }
      }
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });
  }

  signup(FirstName: string, LastName: string, Email: string, Password: string, Mobile: string, Reference: string, PromotionPermission: boolean) {
    const data = new FormData();
    data.append('firstName', FirstName);
    data.append('lastName', LastName)
    data.append('email', Email)
    data.append('password', Password)
    data.append('mobile', `+94${Mobile}`)
    data.append('reference', Reference)
    // data.append('dateOfBirth', DateOfBirth)
    data.append('promotionPermission', JSON.stringify(PromotionPermission));

    this.http.post<{ success: boolean, data: any }>(`${apiUrl}/users`, data).subscribe(result => {
      if (result.data.token) {
        this.isAuthenticated = true;
        this.isAuthenticatedSub.next(true);
        this.token = result.data.token;
        this.saveAuthData(this.token);
        this.dialog.closeAll();
        this.dialog.open(VerifyMobileComponent, { disableClose: true });
        this.saveUser(result.data);
      }

      if (!result.data.verified) {
        const data = new FormData();
        data.append('mobile', `+94${Mobile}`);

        this.dialog.open(VerifyMobileComponent);
        this.http.post<{ success: boolean, data: any }>(`${apiUrl}/users/sms`, data).subscribe(result => {
        }, error => {
          this.snackBar.open(error.error.data, 'Dismiss', {
            duration: 3000
          });
        });
      }
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });
  }

  verifyMobile(code: string) {
    const data = new FormData();
    data.append('verificationCode', code)

    this.http.put<{ success: boolean, data: any }>(`${apiUrl}/users/sms`, data).subscribe(result => {
      if (result.success) {

        let user = JSON.parse(localStorage.getItem('user'));
        user.verfied = true;

        localStorage.setItem('user', JSON.stringify(user));

        if (this.router.url === '/profile') {
          this.router.navigate(['/profile']);
          this.snackBar.open('Mobile number verfired!', 'Dismiss', {
            duration: 3000
          });
        } else if (this.router.url === '/checkout') {
          this.router.navigate(['/checkout']);
          this.snackBar.open('Mobile number verfired. You can place the order now!', 'Dismiss', {
            duration: 3000
          });
        } else {
          this.router.navigate(['/']);
          this.snackBar.open('Welcome to Honest Green!', 'Dismiss', {
            duration: 3000
          });
        }
        this.dialog.closeAll();
      }
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });
  }

  resendVerification(mobile: string) {
    const data = new FormData();
    data.append('mobile', mobile);

    this.http.post<{ success: boolean, data: any }>(`${apiUrl}/users/sms`, data).subscribe(result => {
      if (result.success) {
        this.isAuthenticated = true;
        this.isAuthenticatedSub.next(true);
        this.token = result.data.token;
        this.saveAuthData(this.token);
        this.saveUser(result.data);

        this.dialog.closeAll();
        this.dialog.open(VerifyMobileComponent);
      }
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });
  }

  userLogin(data: any) {
    this.http.post<{ success: boolean, data: any }>(`${apiUrl}/users/login`, data).subscribe(result => {
      if (result.data.token) {
        this.isAuthenticated = true;
        this.token = result.data.token;
        this.saveAuthData(this.token);
        this.isAuthenticatedSub.next(true);

        const subscriptionType = localStorage.getItem('subscriptionType');

        if (subscriptionType == '') {
          localStorage.setItem('subscriptionType', 'One Delivery');
        }

        this.snackBar.open('Welcome to Honest Green!', 'Dismiss', {
          duration: 3000
        });

        this.saveUser(result.data);

        this.dialog.closeAll();

        const clickedStatus = localStorage.getItem('clickedStatus');

        if (!clickedStatus) {
          this.router.navigate(['/']);
        } else if (clickedStatus === 'checkout') {
          this.router.navigate(['/checkout']);
        } else if (clickedStatus === 'profile') {
          this.router.navigate(['/profile']);
        }
      }
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });
  }

  logout() {
    this.token = null;
    this.isAuthenticated = false;

    localStorage.removeItem('token');
    localStorage.removeItem('adminName');
    localStorage.removeItem('clickedStatus');

    this.router.navigate(['/admin/login']);
    this.snackBar.open('See you soon!', 'Dismiss', {
      duration: 3000
    });
  }

  userLogout() {
    this.token = null;
    this.isAuthenticated = false;
    this.isAuthenticatedSub.next(false);

    localStorage.setItem('token', '');
    localStorage.removeItem('user');
    localStorage.removeItem('clickedStatus');

    this.router.navigate(['/']);
    this.snackBar.open('See you soon!', 'Dismiss', {
      duration: 3000
    })
  }

  resetPasswordRequestCode(data: any, mobile: string) {
    this.http.post<{ success: boolean, data: any }>(`${apiUrl}/users/passwords`, data).subscribe(result => {
      if (result.success) {
        this.dialog.closeAll();
        this.dialog.open(ResetPasswordComponent);
        localStorage.setItem('resetMobile', `+94${mobile}`);
        this.snackBar.open('Verification code sent to your mobile', 'Dismiss', {
          duration: 3000
        });
      }
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });
  }

  resetPassword(data: any) {
    this.http.put<{ success: boolean, data: any }>(`${apiUrl}/users/passwords`, data).subscribe(result => {
      if (result.success) {
        this.dialog.closeAll();
        this.dialog.open(LoginComponent);
        localStorage.removeItem('resetMobile');
        this.snackBar.open('Password updated successfully', 'Dismiss', {
          duration: 3000
        });
      }
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });
  }

  autoAuthUser() {
    const token = this.getAuthData();

    if (!token) {
      this.isAuthenticated = false;
      this.isAuthenticatedSub.next(this.isAuthenticated);
      return;
    }

    this.token = token;
    this.isAuthenticated = true;
    this.isAuthenticatedSub.next(this.isAuthenticated);
  }

  private saveAuthData(token: string) {
    localStorage.setItem('token', token);
  }

  saveUser(data: any) {

    const user = JSON.stringify({
      _id: data._id,
      name: data.name,
      mobile: data.mobile,
      email: data.email,
      verfied: data.verified,
      dateOfBirth: data.dateOfBirth,
      createdAt: data.createdAt,
      addresses: data.addresses,
      cards: data.cards,
      serviceAgent: data.serviceAgent,
      serviceAgentMobile: data.serviceAgentMobile,
      userType: data.userType
    })

    localStorage.setItem('user', user);
  }

  private getAuthData() {
    const token = localStorage.getItem('token');

    if (!token) {
      return;
    }

    return token;
  }
}
